<template>
    <div class="animated fadeIn">
        <bread-crumbs :title="`Обращения`" :items="[{title: 'Главная', url: '/#/'}, {title: 'Профиль', url: '/admin/profile'}]"/>
        <div class="wrapper wrapper-content">
            <ibox>
                <ibox-title :hide-tools="true">
                    Обращения
                </ibox-title>
                <ibox-content>
                    <b-table 
                        v-if="data && data.length > 0"
                        striped 
                        hover 
                        bordered 
                        responsive 
                        :fields="fields" 
                        :items="data">
                        <template v-slot:cell(name)="data">
                            {{ data.item.name }}
                        </template>
                        <template v-slot:cell(email)="data">
                            <a :href="`mailto:${data.item.email}`" class="btn btn-sm btn-primary">
                                <i class="fa fa-envelope"></i> {{ data.item.email }}
                            </a>
                        </template>
                        <template v-slot:cell(phone)="data">
                            <a :href="`tel:${data.item.phone}`" class="btn btn-sm btn-success">
                                <i class="fa fa-phone"></i> {{ data.item.phone }}
                            </a>
                        </template>
                        <template v-slot:cell(message)="data">
                            <div style="max-width: 400px; word-wrap: break-word;">
                                {{ data.item.message || 'Нет сообщения' }}
                            </div>
                        </template>
                        <template v-slot:cell(createdAt)="data">
                            {{ data.item.createdAt | formatDate }}
                        </template>
                        <template v-slot:cell(action)="data">
                            <b-btn size="sm" variant="danger" @click="onDelete(data.item.id)">Удалить</b-btn>
                        </template>
                    </b-table>
                    <div v-else-if="data && data.length === 0" class="text-center p-4">
                        <p>Список обращений пуст</p>
                    </div>
                    <div v-else class="text-center p-4">
                        <p>Загрузка...</p>
                    </div>
                </ibox-content>
            </ibox>
        </div>
    </div>
</template>

<script>
    import BreadCrumbs from "../BreadCrumbs";
    import Ibox from "../Ibox/Ibox";
    import IboxTitle from "../Ibox/IboxTitle";
    import IboxContent from "../Ibox/IboxContent";
    export default {
        name: "FeedbackList",
        components: {IboxContent, IboxTitle, Ibox, BreadCrumbs},
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Имя'
                    },
                    {
                        key: 'email',
                        label: 'Email'
                    },
                    {
                        key: 'phone',
                        label: 'Телефон'
                    },
                    {
                        key: 'message',
                        label: 'Сообщение'
                    },
                    {
                        key: 'createdAt',
                        label: 'Дата обращения'
                    },
                    {
                        key: 'action',
                        label: 'Действия'
                    },
                ],
                data: []
            }
        },
        methods: {
            load() {
                this.axios.get('feedbacks', {
                    params: {
                        'order[id]': 'DESC'
                    }
                }).then(res => {
                    // API Platform может возвращать данные в формате hydra:member или напрямую массив
                    let newData = [];
                    if (res.data['hydra:member']) {
                        newData = res.data['hydra:member'];
                    } else if (Array.isArray(res.data)) {
                        newData = res.data;
                    }
                    // Обновляем данные напрямую для обеспечения реактивности
                    this.data = newData;
                }).catch(() => {
                    this.$toasted.global.appError('Ошибка при загрузке обращений');
                })
            },
            onDelete(id) {
                this.$bvModal.msgBoxConfirm('Вы уверены, что хотите удалить обращение? Это действие необратимо.', {
                    title: 'Удаление обращения',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Да',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(res => {
                        if(res) {
                            this.axios.delete('feedbacks/' + id)
                                .then(() => {
                                    this.$toasted.global.appSuccess('Обращение удалено');
                                    // Обновляем список после удаления
                                    this.load();
                                })
                                .catch((error) => {
                                    console.error('Ошибка при удалении обращения:', error);
                                    this.$toasted.global.appError('Ошибка при удалении обращения');
                                });
                        }
                    })
                    .catch(() => {
                        // Пользователь закрыл модальное окно без выбора
                    })
            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>

</style>

